import { useEffect, useState } from 'react';

export const useWristSize = (
  currentStrapSize?: string | null,
  unit?: 'mm' | 'inch',
) => {
  const sizeMap = {
    mm: {
      default: { min: 160, max: 190 },
      Large: { min: 190, max: 215 },
      Small: { min: 135, max: 160 },
    },
    inch: {
      default: { min: 6.3, max: 7.5 },
      Large: { min: 7.5, max: 8.5 },
      Small: { min: 5.3, max: 6.3 },
    },
  };

  const [wristInterval, setWristInterval] = useState(
    sizeMap[unit ?? 'inch'].default,
  );

  useEffect(() => {
    const newInterval =
      currentStrapSize &&
      (currentStrapSize === 'Large' || currentStrapSize === 'Small')
        ? sizeMap[unit ?? 'inch'][currentStrapSize]
        : sizeMap[unit ?? 'inch'].default;

    if (
      wristInterval.min !== newInterval.min ||
      wristInterval.max !== newInterval.max
    ) {
      setWristInterval(newInterval);
    }
  }, [currentStrapSize, unit]);

  return wristInterval;
};
